import { gql, useQuery } from '@apollo/client';
import Container from 'ls-common-client/src/components/Container';

import React, { memo, useContext, useEffect, useMemo, useRef } from 'react';
import { Context } from '../../../context/AppContext';

const widgetMenuQuery = gql`
  query WidgetFragmentAppMenu(
    $variant: String!
    $appParameters: ParametersAppMenu
    $userParameters: ParametersUserMenu
  ) {
    widgetFragmentUserMenu(variant: $variant, parameters: $userParameters) {
      html
    }
    widgetFragmentAppMenu(variant: $variant, parameters: $appParameters) {
      html
    }
  }
`;

const SysMenus = ({ size = '34px', ...props }) => {
  const {
    user: { loading, user },
    auth,
  } = useContext(Context);

  const { data: widgetMenusData, loading: loadingMenu } = useQuery(
    widgetMenuQuery,
    {
      variables: {
        variant: 'night',
        appParameters: {
          size: '100%',
          colorNormal1: '#5c82fc',
        },
        userParameters: {
          size: '100%',
          dataLayerName: 'PageDataLayer',
          fullScreenZIndex: 2001,
          colorNormal1: '#5c82fc',
        },
      },
    }
  );

  const { appMenuHtml, userMenuHtml } = useMemo(() => {
    const { widgetFragmentAppMenu, widgetFragmentUserMenu } =
      widgetMenusData || {};
    return {
      userMenuHtml: widgetFragmentUserMenu ? widgetFragmentUserMenu.html : '',
      appMenuHtml: widgetFragmentAppMenu ? widgetFragmentAppMenu.html : '',
    };
  }, [widgetMenusData]);

  const intervalRef = useRef(0);

  useEffect(() => {
    if ((!userMenuHtml && !appMenuHtml) || loading) {
      return;
    }
    if (intervalRef.current) {
      clearTimeout(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      if (window.lsWidget?.fragments) {
        clearTimeout(intervalRef.current);
        intervalRef.current = 0;
        window.lsWidget.fragments.common.auth.setAuth({ auth, user });
      }
    }, 100);
  }, [userMenuHtml, appMenuHtml, loading, user]);

  return (
    <Container display="flex" alignItems="center" {...props}>
      {!loadingMenu && appMenuHtml && auth.token() && (
        <Container
          dangerouslySetInnerHTML={{ __html: appMenuHtml }}
          width={size}
          height={size}
          marginLeft="10px"
          transition="none"
        />
      )}
      {!loadingMenu && userMenuHtml && (
        <Container
          dangerouslySetInnerHTML={{ __html: userMenuHtml }}
          width={size}
          height={size}
          marginLeft="15px"
          transition="none"
          textAlign="left"
        />
      )}
    </Container>
  );
};

export default memo(SysMenus);
